import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import ProductKiezer from '../js/components/ProductKiezer';
import VerbruikSelection from '../js/components/VerbruikKiezer';
import VerbruikInput from '../js/components/WatIsJeVerbruik';
import AdresKiezer from '../js/components/AdresKiezer';
import ParticulierVerbruikEstimaterStep1 from '../js/components/VerbruikEstimater/Particulier/Step1';
import ParticulierVerbruikEstimaterStep2 from '../js/components/VerbruikEstimater/Particulier/Step2';
import ZakelijkeVragen from '../js/components/VerbruikEstimater/Zakelijk';
import EntiteitKiezer from '../js/components/EntiteitKiezer';
import PakketKiezer from '../js/components/PakketKiezer';
import TerugleveringInput from '../js/components/HoeveelStroomTerug';
import SelfStroomOpwekking from '../js/components/WekJeZelfStroomOp';
import PersoonsGegevens from '../js/components/PersoonsGegevens';
import ContactGegevens from '../js/components/ContactGegevens';
import BestellingOverzicht from '../js/components/BestellingOverzicht';
import BestellingAanmaken from '../js/components/BestellingAanmaken';
import ExtraOptions from '../js/components/ExtraOptions';
import ExplainerHeader from '../js/components/ExplainerHeader';
import Betrouwbaarheid from '../js/components/Betrouwbaarheid';
import MultipleEanSelection from '../js/components/MultipleEanSelection';
import StepperComponent from '../js/components/Stepper';
const App = () => {


  function getAddressInformationFromLocalStorage() {
    var addressInformation = JSON.parse(localStorage.getItem('addressInformation'));
    if (addressInformation != null) {
      var postcode = addressInformation.postcode;
      var housenumber = addressInformation.housenumber;
      var housenumberSuffix = addressInformation.suffix === "Geen" || addressInformation.suffix === "" ? null : addressInformation.suffix;
      var business = addressInformation.business;
      var availableMeters = addressInformation.available_meters;
      var streetName = addressInformation.streetName;
      var cityName = addressInformation.city;
      var suffixList = addressInformation.suffixList;
    } else {
      var postcode = null;
      var housenumber = null;
      var housenumberSuffix = null;
      var business = null;
      var availableMeters = null;
      var streetName = null;
      var cityName = null;
      var suffixList = null;
    }
    return {
      postcode: postcode,
      housenumber: housenumber,
      housenumberSuffix: housenumberSuffix,
      business: business,
      available_meters: availableMeters,
      streetName: streetName,
      cityName: cityName,
      suffixList: suffixList
    }
  }

  const [currentStep, setCurrentStep] = useState(0);
  const [isFetchingData, setIsFetchingData] = useState(false); // State to keep track of when data is being fetched
  const [returnsEnergy, setReturnsEnergy] = useState(false); // We don't ask the user whether they return energy anymore, so set to false by default.
  const [returnedEnergyAmount, setReturnedEnergyAmount] = useState(null);
  const [postcode, setPostcode] = useState('');
  const [streetName, setStreetName] = useState('');
  const [cityName, setCityName] = useState('');
  const [housenumber, setHousenumber] = useState('');
  // Note that this state is only used to make sure that when the user navigates back to the AdresKiezer page,
  // that the housenumberSuffix field is still enabled. The value of this variable does not imply that the actual
  // address is valid, rather just the format of the fields.
  const [isPostCodeAndHouseNumberFormatValid, setIsPostCodeAndHouseNumberFormatValid] = useState(false);
  const [housenumberSuffix, setHousenumberSuffix] = useState('');
  const [selectedEan, setSelectedEan] = useState(null);
  const [housenumberSuffixList, setHousenumberSuffixList] = useState({});
  const [houseNumberSuffixesOnAddress, sethouseNumberSuffixesOnAddress] = useState({});
  const [verbruikEstimaterStep1Output, setVerbruikEstimaterStep1Output] = useState(null);
  const [verbruikEstimaterStep2Output, setVerbruikEstimaterStep2Output] = useState(null);
  const [verbruikEstimaterStep2BuildingType, setVerbruikEstimaterStep2BuildingType] = useState(null);
  const [finalChosenUsage, setFinalChosenUsage] = useState(null);
  const [availableMeterTypes, setAvailableMeterTypes] = useState([]);
  const [multipleEanCodesForProducts, setMultipleEanCodesForProducts] = useState({});
  const [anyRelevantMultipleEanCodes, setAnyRelevantMultipleEanCodes] = useState(false);
  const [geslacht, setGeslacht] = useState('');
  const [voornaam, setVoornaam] = useState('');
  const [achternaam, setAchternaam] = useState('');
  const [geboorteDatum, setGeboorteDatum] = useState('');
  const [telefoonnummer, setTelefoonnummer] = useState('');
  const [email, setEmail] = useState('');
  const [chosenProduct, setChosenProduct] = useState([]);
  const [chosenPakket, setChosenPakket] = useState([]);
  const [entiteit, setEntiteit] = useState('');
  const [kvkNummer, setKvkNummer] = useState('');
  const [bedrijfsNaam, setBedrijfsnaam] = useState('');
  const [verbruikEstimaterRequired, setVerbruikEstimaterRequired] = useState(false);
  const [warmtepomp, setWarmtepomp] = useState(false);
  const [electricCarWithCharger, setElectricCarWithCharger] = useState(false);
  const [slimmeMeter, setSlimmeMeter] = useState(false);
  const [termsOfServicesAccepted, setTermsOfServicesAccepted] = useState('');
  const [overstapDatum, setOverstapDatum] = useState('');
  const [betaalmethode, setBetaalmethode] = useState('');
  const [validationSucceeded, setValidationSucceeded] = useState([]);
  const [submissionSuccessful, setSubmissionSuccessful] = useState(false);
  const [submissionFailed, setSubmissionFailed] = useState(false);
  const [submissionFailedWithReasons, setSubmissionFailedWithReasons] = useState(false);


  const [validationErrors, setValidationErrors] = useState({
    step0: [],
    step1: [],
    step2: [],
    step3: [],
    step4: [],
    step5: [],
    step6: [],
    step7: [],
    step8: [],
    step9: [],
    step10: [],
    step11: [],
    step12: [],
    step13: [],
    step14: [],
  });

  /**
   * Callback function to update the validationErrors state.
   * 
   * @param {*} step The step to update the validation errors for
   * @param {*} errors Contains the errors for the step. Can be a message string or an array. If an array, 
   * the first item in the array should be the message string and the second item should be a boolean to indicate whether
   * the message should be shown in the error box or not.
   */
  const handleValidationErrorsUpdate = (step, errors) => {
    // If there are errors, add them to the validationErrors state
    if (errors.length > 0) {
      setValidationErrors(prevErrors => ({
        ...prevErrors,
        [step]: [errors],
      }));
      // otherwise, remove the errors from the validationErrors state
    } else {
      setValidationErrors(prevErrors => ({
        ...prevErrors,
        [step]: [],
      }));
    }
  };


  const steps = {
    'Samenstellen': [0, 10],
    'Aanbieding': [11],
    'Gegevens': [12, 13],
    'Bestellen': [14],
    'Bedankt': [15],
  };





  /**
   * Returns the current group based on the current step.
   * @param {*} currentStep
   * @returns
   */
  const getCurrentGroup = (currentStep) => {
    return Object.keys(steps).find(group =>
      currentStep >= steps[group][0] && currentStep <= (steps[group][1] || steps[group][0])
    );
  };


  /**
   * Update the current group when the current step changes.
   */
  useEffect(() => {
    const newGroup = getCurrentGroup(currentStep);
    if (newGroup !== currentGroup) {
      setCurrentGroup(newGroup);
    }
  }, [currentStep]);


  /**
   * State to keep track of the current group.
   */
  const [currentGroup, setCurrentGroup] = useState(getCurrentGroup(currentStep));

  /**
   * Handle the group step click
   * @param {*} group
   */
  const handleGroupStepClick = (group) => {
    const groupIndex = Object.keys(steps).indexOf(group);
    const currentGroupIndex = Object.keys(steps).indexOf(currentGroup);

    if (groupIndex < currentGroupIndex) {
      const stepRange = steps[group];
      setCurrentStep(stepRange[0]);
      setCurrentGroup(group);
    }
  };




  const mapComponentsToSteps = {
    0: AdresKiezer,
    1: EntiteitKiezer,
    2: ProductKiezer,
    3: MultipleEanSelection,
    4: ExtraOptions,
    5: VerbruikSelection,
    6: ParticulierVerbruikEstimaterStep1,
    7: ParticulierVerbruikEstimaterStep2,
    8: VerbruikInput,
    9: SelfStroomOpwekking,
    10: TerugleveringInput,
    11: PakketKiezer,
    12: PersoonsGegevens,
    13: ContactGegevens,
    14: BestellingOverzicht,
  };

  const mapVariablesToComponents = {
    AdresKiezer: {
      postcode: postcode,
      housenumber: housenumber,
    },
    EntiteitKiezer: {
      entiteit: entiteit,
    },
    ProductKiezer: {
      chosenProduct: chosenProduct,
    },
    VerbruikSelection: {
      verbruikEstimaterRequired: verbruikEstimaterRequired,
    },

    MultipleEanSelection: {

    },

    ParticulierVerbruikEstimaterStep1: {
      verbruikEstimaterStep1Output: verbruikEstimaterStep1Output,
    },

    ParticulierVerbruikEstimaterStep2: {
      verbruikEstimaterStep2BuildingType: verbruikEstimaterStep2BuildingType,
    },
    VerbruikInput: {
      finalChosenUsage: finalChosenUsage,
    },

    SelfStroomOpwekking: {
      returnsEnergy: returnsEnergy,
    },

    TerugleveringInput: {
      returnedEnergyAmount: returnedEnergyAmount,
    },

    PakketKiezer: {
    },

    ExtraOptions: {
      slimmeMeter: slimmeMeter,
    },

    PersoonsGegevens: {
      geslacht: geslacht,
      voornaam: voornaam,
      achternaam: achternaam,
      geboorteDatum: geboorteDatum,
      entiteit: entiteit
    },




    ContactGegevens: {
      telefoonnummer: telefoonnummer,
      email: email
    },

    BestellingOverzicht: {
      termsOfServicesAccepted: termsOfServicesAccepted,
    },

    BestellingAanmaken: {
      termsOfServicesAccepted: termsOfServicesAccepted,
    },

  };

  // Add KvK number and bedrijfsnaam to the mapVariablesToComponents object if the user is a business
  if (entiteit == "Zakelijk") {
    mapVariablesToComponents.PersoonsGegevens.kvkNummer = kvkNummer;
    mapVariablesToComponents.PersoonsGegevens.bedrijfsnaam = bedrijfsNaam;
  }

  if (multipleEanCodesForProducts) {
    // check if multipleEanCodesForProducts.GAS exists
    if (multipleEanCodesForProducts.GAS) {
      if (selectedEan && selectedEan.RequiredGasMeterEAN) {
        mapVariablesToComponents.MultipleEanSelection.RequiredGasMeterEAN = selectedEan.RequiredGasMeterEAN;
      } else {
        mapVariablesToComponents.MultipleEanSelection.RequiredGasMeterEAN = null;
      }
    }

    if (multipleEanCodesForProducts.ELK) {
      if (selectedEan && selectedEan.RequiredStroomMeterEAN) {
        mapVariablesToComponents.MultipleEanSelection.RequiredStroomMeterEAN = selectedEan.RequiredStroomMeterEAN;
      } else {
        mapVariablesToComponents.MultipleEanSelection.RequiredStroomMeterEAN = null;
      }
    }
  }


  const fieldToFriendlyNameMap = {
    'e_high': 'Wil je ook hoog opgeven? Indien geen, vul dan 0 in.',
    'e_low': 'Wil je ook laag opgeven? Indien geen, vul dan 0 in.',
    'gas': 'Gelieve je gasverbruik in te vullen',
    'postcode': 'Gelieve je postcode in te vullen',
    'housenumber': 'Gelieve je huisnummer in te vullen',
    'finalChosenUsage': 'Gelieve je verbruik in te vullen',
    'entiteit': 'Gelieve je entiteit in te vullen',
    'chosenProduct': 'Gelieve je product in te vullen',
    'returnedEnergyAmount': 'Gelieve je teruggeleverde energie in te vullen',
    'returnsEnergy': 'Gelieve aan te geven of u zelf stroom opwekt',
    'return_high': 'Wil je ook hoog opgeven? Indien geen, vul dan 0 in.',
    'return_low': 'Wil je ook laag opgeven? Indien geen, vul dan 0 in.',
    'aanhef': 'Gelieve je aanhef in te vullen',
    'voornaam': 'Gelieve je voornaam in te vullen',
    'achternaam': 'Gelieve je achternaam in te vullen',
    'geboortedatum': 'Gelieve je geboortedatum in te vullen',
    'telefoonnummer': 'Gelieve je telefoonnummer in te vullen',
    'email': 'Gelieve je email in te vullen',
    'geslacht': 'Gelieve je aanhef in te vullen',
    'geboorteDatum': 'Gelieve je geboortedatum in te vullen',
    'slimmeMeter': 'Een slimme meter is verplicht',
    'termsOfServicesAccepted': 'Je moet de algemene voorwaarden accepteren voor je de bestelling kunt plaatsen',
    'bedrijfsnaam': 'Gelieve je bedrijfsnaam in te vullen',
    'kvkNummer': 'Gelieve je KvK nummer in te vullen',
    'selectedEan': 'Gelieve je EAN codes te selecteren. Kom je er niet uit? Neem dan contact op met onze klantenservice.',
    'RequiredGasMeterEAN': "Gelieve je gas EAN code te selecteren. Kom je er niet uit? Neem dan contact op met onze klantenservice.",
    'RequiredStroomMeterEAN': "Gelieve je stroom EAN code te selecteren. Kom je er niet uit? Neem dan contact op met onze klantenservice.",
  };



  /**
   *
   * @function getErrorMessageForComponent
   * @description Get the error message for a component
   * @param {*} component The component to get the error message for
   * @returns The error message for the component
   */
  function getErrorMessageForComponent(component) {
    let displayName = component.displayName;
    let variables = mapVariablesToComponents[displayName];
    let errorMessages = [];


    errorMessages.push(...validationErrors[`step${currentStep}`]);

    // Recursively validate nested objects. This is neccesary because some components have nested objects as props.
    // and we need to validate those as well.
    const validateFields = (obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (key == 'verbruikEstimaterStep1Output' && entiteit == "Zakelijk") {
          return;
        } else {
          if (key === 'slimmeMeter' && value !== true) {
            errorMessages.push(fieldToFriendlyNameMap[key]);
          } else if (value === '' || value === undefined || value === null) {
            let friendlyName = fieldToFriendlyNameMap[key] ? fieldToFriendlyNameMap[key] : key;
            // only push if the error message is not already in the array
            if (!errorMessages.includes(friendlyName)) {
              errorMessages.push(friendlyName);
            }
          } else if (typeof value === 'object') {
            // Recursively validate nested objects
            validateFields(value);
          } else {
            // remove friendly name from errorMessages if it exists
            let friendlyName = fieldToFriendlyNameMap[key] ? fieldToFriendlyNameMap[key] : key;
            errorMessages = errorMessages.filter(item => item !== friendlyName);

          }
        }
      });
    };

    validateFields(variables);

    return errorMessages;
  }



  /**
   * Get the address information from the local storage if it exists. Skip the first step if it does.
   */
  useEffect(() => {
    const addressInformation = getAddressInformationFromLocalStorage();
    if (addressInformation.postcode != null) {
      setPostcode(addressInformation.postcode);
      setHousenumber(addressInformation.housenumber);
      setHousenumberSuffix(addressInformation.housenumberSuffix);
      setAvailableMeterTypes(addressInformation.available_meters ?? []);
      setStreetName(addressInformation.streetName);
      setCityName(addressInformation.cityName);
      sethouseNumberSuffixesOnAddress(addressInformation.suffixList ?? []);
      setHousenumberSuffixList(addressInformation ?? []);
      sendToDataLayer(0);
      setCurrentStep(1);
    }
  }, []);


  /**
   * Validate the fields any of the fields change
   */
  useEffect(() => {
    validateFieldsNotEmpty();
  }, [postcode, housenumber, entiteit, chosenProduct, verbruikEstimaterRequired, verbruikEstimaterStep1Output, verbruikEstimaterStep2BuildingType, finalChosenUsage, termsOfServicesAccepted]);


  /**
   * Validate the fields are not empty
   * @returns Object - Returns an object with the validation result and error messages
   */
  function validateFieldsNotEmpty() {

    let Component = mapComponentsToSteps[currentStep];
    let errorMessageForComponent = getErrorMessageForComponent(Component);
    if (errorMessageForComponent !== '') {
      setValidationSucceeded({
        isValid: false,
        errorMessages: errorMessageForComponent,
      });
      return {
        isValid: false,
        errorMessages: errorMessageForComponent,
      };
    } else {
      setValidationSucceeded({
        isValid: true,
        errorMessages: [],
      });
      validationErrors[`step${currentStep}`] = [];

      return {
        isValid: true,
        errorMessages: [],
      };
    }
  }


  /**
   * This function is triggered after a user successfully inputs their address
   * details during the initial stage (and clicks the "Volgende" button). Its purpose is to update the local storage 
   * with the user's latest address data. Initially, any address input provided on the
   * homepage is stored in local storage. If a user revises their address during the
   * initial step of the 'aanmeldstraat' process and then refreshes the page, without
   * this function, the local storage would still contain the outdated address details.
   * This function ensures that any changes made to the address during the 'aanmeldstraat'
   * step are immediately captured by removing the existing address from local storage 
   * and saving the updated address data. Consequently, if the page is refreshed, 
   * it will reflect the most current address details as entered in the 'aanmeldstraat'.
   */
  function setAddressInLocalStorage() {
    // Clears the previous address information from local storage.
    localStorage.removeItem('addressInformation');
    // Compiles the new address information from the input fields.

    var addressInformation = {
      available_meters: availableMeterTypes,
      streetName: streetName,
      city: cityName,
      postcode: postcode,
      housenumber: housenumber,
      suffix: housenumberSuffix,
      suffixList: houseNumberSuffixesOnAddress
    };
    // Stores the updated address information into local storage.
    localStorage.setItem('addressInformation', JSON.stringify(addressInformation));
  }

  /**
   * @function onNextClick - Handle the next button click
   * @description This function is called when the next button is clicked. It validates the fields and shows the next step if the validation succeeds.
   */
  function onNextClick() {
    const errorMessagesForComponent = getErrorMessageForComponent(mapComponentsToSteps[currentStep]);
    const isValid = errorMessagesForComponent.every(item => Array.isArray(item) && item.length === 0);
    setValidationSucceeded({
      isValid: isValid,
      errorMessages: errorMessagesForComponent,
    });

    if (isValid) {
      if (currentStep === 0) {
        setAddressInLocalStorage();
      }
      
      let nextStep = currentStep + 1;
      sendToDataLayer(currentStep);
      // Special case when transitioning from step 8 based on `returnsEnergy`
      if (currentStep === 9) {
        if (returnsEnergy) {
          nextStep = 10; // Proceed to return energy input if energy is returned
        } else {
          nextStep = 11; // Skip to package selection if no energy is returned
        }
      } else if (currentStep === 10) {
        nextStep = 11; // Always move to the package selection after energy return input
      }

      // Special case when transitioning from step 4 based on `verbruikEstimaterRequired`
      if (currentStep === 5 && !verbruikEstimaterRequired) {
        nextStep = 8;
      }

      // Clear the error messages for the current step if validation passes
      setValidationErrors(prevState => ({
        ...prevState,
        [`step${currentStep}`]: [],
      }));

      // Add the current step to the step history
      setCurrentStep(nextStep);
    } else {
      // If validation fails, set the errors for the current step
      setValidationErrors(prevState => ({
        ...prevState,
        [`step${currentStep}`]: errorMessagesForComponent,
      }));
    }
  }

  const hasNonEmptyErrors = (errors) => {
    return errors.some(error => Array.isArray(error) ? error.length > 0 : error);
  };

  
  /**
   * Sends data to DataLayer. The current step determines which data is sent.
   * @param {*} currentStep 
   */
  function sendToDataLayer(currentStep) {

    var stepEventMappings = {
      0: "postcodeIngevuld",
      1: "zakelijk_of_particulier",
      2: "energieproduct",
      4: "slimme_meter",
      5: "energieverbruik",
      7: "pand",
      8: "verbruik_ingevuld",
      9: "stroom_opwekken",
      10: "terug_leveren",
      11: "onze_aanbieding",
      12: "persoonsgegevens",
      13: "contact_gegevens",
      14: "gegevens_overzicht"
    };
    var eventMapping = stepEventMappings[currentStep];
    if (eventMapping !== undefined) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': stepEventMappings[currentStep]
      });
    }
  };


  /**
   * @function onPrevClick - Handle the previous button click
   * @description This function is called when the previous button is clicked. It resets the validation state and shows the previous step.
   * @param {*} event
   */
  function onPrevClick(event) {
    event.preventDefault();

    // Clear the specific error message for the current step
    setValidationErrors(prevState => ({
      ...prevState,
      [`step${currentStep}`]: []
    }));

    // Reset the validation succeeded state
    setValidationSucceeded({
      isValid: true,
      errorMessages: [],
    });


    // If we're on step 6 and 'entiteit' is 'Zakelijk', go back to step 4
    if (currentStep === 7 && entiteit === "Zakelijk") {
      setCurrentStep(5);
    }

    else if (currentStep === 4 && (Object.keys(multipleEanCodesForProducts).length == 0 || !anyRelevantMultipleEanCodes)) {
      // go back to step 2 instead of 3, otherwise we just get redirected back to step 4 again
      setCurrentStep(2);
    }

    // Special handling for moving back from step 10 to step 8 or 9 based on `returnsEnergy`
    else if (currentStep === 11) {
      // We don't ask the user if they return energy anymore, so set current step to 8.
      //setCurrentStep(returnsEnergy ? 10 : 9);
      setCurrentStep(8);
    }
    // Special handling for moving back from step 7 to step 4 if `verbruikEstimaterRequired` is false
    else if (currentStep === 8 && !verbruikEstimaterRequired) {
      setCurrentStep(5);
    }
    // Special handling for moving back from steps 9 to step 8 directly if `returnsEnergy` is false
    else if (currentStep === 10) {
      setCurrentStep(9);
    }
    else {
      // Default behavior for other steps
      setCurrentStep(currentStep - 1);
    }
  }




  /**
   * @function renderStep - Render the current step
   * @description This function renders the current step.
   * @returns
   */
  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <div class="AdresKiezer">
            <AdresKiezer
              setIsFetchingData={setIsFetchingData}
              postcode={postcode}
              housenumber={housenumber}
              suffix={housenumberSuffix}
              setPostcode={setPostcode}
              setHousenumber={setHousenumber}
              onValidationChange={setValidationSucceeded}
              isPostCodeAndHouseNumberFormatValid={isPostCodeAndHouseNumberFormatValid}
              setIsPostCodeAndHouseNumberFormatValid={setIsPostCodeAndHouseNumberFormatValid}
              setAvailableMeterTypes={setAvailableMeterTypes}
              housenumberSuffixList={housenumberSuffixList}
              setHousenumberSuffixList={setHousenumberSuffixList}
              setHousenumberSuffix={setHousenumberSuffix}
              sethouseNumberSuffixesOnAddress={sethouseNumberSuffixesOnAddress}
              streetName={streetName}
              setStreetName={setStreetName}
              setCityName={setCityName}
              cityName={cityName}
              onUpdateValidationErrors={(errors) => handleValidationErrorsUpdate("step0", errors)}


            />
          </div>
        );
      case 1:
        return (
          <div class="EntiteitKiezer">
            <EntiteitKiezer entiteit={entiteit} setChosenEntiteit={setEntiteit} setBedrijfsnaam={setBedrijfsnaam} setKvkNummer={setKvkNummer} />
          </div>
        );

      case 2:
        return (
          <div>
            <ProductKiezer
              previousChosenProduct={chosenProduct}
              setChosenProduct={setChosenProduct}
              availableMeterTypes={availableMeterTypes}
              postcode={postcode}
              housenumber={housenumber}
              suffix={housenumberSuffix}
              streetName={streetName}
              cityName={cityName}
              setMultipleEanCodesForProducts={setMultipleEanCodesForProducts}
              onUpdateValidationErrors={(errors) => handleValidationErrorsUpdate("step2", errors)}
            />
          </div>

        );


      case 3:
        // Only continue with this step if the actual chosen product has multiple EAN codes.
        let metersToDisplay = {
          RequiredGasMeterEAN: chosenProduct.includes('Gas') ? multipleEanCodesForProducts.Gas || [] : [],
          RequiredStroomMeterEAN: chosenProduct.includes('Electriciteit') ? multipleEanCodesForProducts.ELK || [] : []
        };
        if (Object.values(metersToDisplay).some(arr => arr.length !== 0)) {
          return (

            <div class="MultipleEanSelection">
              <MultipleEanSelection
                chosenProduct={chosenProduct}
                postcode={postcode}
                huisnummer={housenumber}
                housenumberSuffix={housenumberSuffix}
                streetName={streetName}
                cityName={cityName}
                selectedEan={selectedEan}
                multipleEanCodesForProducts={multipleEanCodesForProducts}
                setSelectedEan={setSelectedEan}
                setAnyRelevantMultipleEanCodes={setAnyRelevantMultipleEanCodes}
                onUpdateValidationErrors={(errors) => handleValidationErrorsUpdate("step3", errors)}

              >
              </MultipleEanSelection>
            </div>
          )
        } else {
          // No relevant multiple EAN codes, skip this step
          setAnyRelevantMultipleEanCodes(false);
          setCurrentStep(4);
        }
      case 4:
        return (
          <div class="ExtraOptions">
            <ExtraOptions
              electricCarWithCharger={electricCarWithCharger}
              setElectricCarWithCharger={setElectricCarWithCharger}
              chosenProduct={chosenProduct}
              warmtepomp={warmtepomp}
              setWarmtepomp={setWarmtepomp}
              slimmeMeter={slimmeMeter}
              setSlimmeMeter={setSlimmeMeter}
            />
          </div>
        );
      case 5:
        return (
          <div class="VerbruikSelection">
            <VerbruikSelection options={['Ja', 'Nee']} verbruikEstimaterRequired={verbruikEstimaterRequired} setVerbruikEstimaterRequired={setVerbruikEstimaterRequired} />
          </div>
        );
      case 6:
        if (verbruikEstimaterRequired) {
          if (entiteit == "Zakelijk") {
            setCurrentStep(7);

          } else {
            return (
              <div class="verbruikEstimaterStep1">
                <ParticulierVerbruikEstimaterStep1 chosenPersons={verbruikEstimaterStep1Output} setPersonen={setVerbruikEstimaterStep1Output} onValidationChange={setValidationSucceeded} />
              </div>
            );
          }
        }
      case 7:
        if (verbruikEstimaterRequired) {
          if (entiteit == "Zakelijk") {
            return (
              <div class="ZakelijkeVragen">
                <ZakelijkeVragen chosenProduct={chosenProduct} setIsFetchingData={setIsFetchingData} setOutput={setVerbruikEstimaterStep2Output} setBuildingType={setVerbruikEstimaterStep2BuildingType} chosenBuilding={verbruikEstimaterStep2BuildingType} onValidationChange={setValidationSucceeded} />
              </div>
            )
          } else {
            return (
              <div class="verbruikEstimaterStep2">
                <ParticulierVerbruikEstimaterStep2 setIsFetchingData={setIsFetchingData} chosenBuilding={verbruikEstimaterStep2BuildingType} setBuildingType={setVerbruikEstimaterStep2BuildingType} setOutput={setVerbruikEstimaterStep2Output} onValidationChange={setValidationSucceeded} entiteit={entiteit} houseHoldSize={verbruikEstimaterStep1Output} />
              </div>
            );
          }
        }
      case 8:
        return (
          <div class="VerbruikInput">
            <VerbruikInput
              chosenProduct={chosenProduct}
              verbruikEstimaterStep2Output={verbruikEstimaterStep2Output}
              finalChosenUsage={finalChosenUsage}
              onUpdateValidationErrors={(errors) => handleValidationErrorsUpdate("step8", errors)}
              setFinalChosenUsage={setFinalChosenUsage}
            />          </div>
        );
      case 9:
        // We no longer ask the user whether they will return energy, so skip this step as well as the next one 
        setCurrentStep(11);
        // const includesElectricity = chosenProduct.includes("Electriciteit");
        // if (includesElectricity) {
        //   return (
        //     <div class="SelfStroomOpwekking">
        //       <SelfStroomOpwekking
        //         returnsEnergy={returnsEnergy}
        //         setReturnsEnergy={setReturnsEnergy}
        //         setReturnedEnergyAmount={setReturnedEnergyAmount}
        //       />
        //     </div>
        //   )
        // } else {
        //   // No electricity, so no need to ask about returning energy
        //   setCurrentStep(11);
        //   return null;
        // }

      // this is skipped due to setCurrentStep(11); in case 9.
      case 10:
        if (returnsEnergy) {
          return (
            <div class="TerugLeveringInput">
              <TerugleveringInput
                returnedEnergyAmount={returnedEnergyAmount}
                setReturnedEnergyAmount={setReturnedEnergyAmount}
              />
            </div>
          );
        }
      case 11:
        return (
          <div class="PakketKiezer">
            <PakketKiezer
              address={{ postcode: postcode, housenumber: housenumber, housenumberSuffix: housenumberSuffix }}
              chosenProduct={chosenProduct}
              chosenUsage={finalChosenUsage}
              returnedEnergyAmount={returnedEnergyAmount}
              chosenEntity={entiteit}
              setIsFetchingData={setIsFetchingData}
              setChosenPakket={setChosenPakket}
            />
          </div>
        );
      case 12:
        return (
          <div class="PersoonsGegevens">
            <PersoonsGegevens
              geslacht={geslacht}
              setGeslacht={setGeslacht}
              voornaam={voornaam}
              setVoornaam={setVoornaam}
              achternaam={achternaam}
              setAchternaam={setAchternaam}
              geboorteDatum={geboorteDatum}
              setGeboorteDatum={setGeboorteDatum}
              zakelijk={entiteit}
              kvkNummer={kvkNummer}
              setKvkNummer={setKvkNummer}
              bedrijfsnaam={bedrijfsNaam}
              setBedrijfsnaam={setBedrijfsnaam}
              onUpdateValidationErrors={(errors) => handleValidationErrorsUpdate("step12", errors)}
            />
          </div>
        )
      case 13:
        return (
          <div class="ContactGegevens">
            <ContactGegevens
              onUpdateValidationErrors={(errors) => handleValidationErrorsUpdate("step13", errors)}
              telefoonnummer={telefoonnummer}
              setTelefoonnummer={setTelefoonnummer}
              email={email}
              setEmail={setEmail}

            />
          </div>
        )
      case 14:
        return (
          <div class="BestellingOverzicht">
            <BestellingOverzicht
              telefoonnummer={telefoonnummer}
              email={email}
              voornaam={voornaam}
              achternaam={achternaam}
              geboorteDatum={geboorteDatum}
              streetName={streetName}
              cityName={cityName}
              postcode={postcode}
              huisnummer={housenumber}
              housenumberSuffix={housenumberSuffix}
              chosenPakket={chosenPakket}
              setTermsOfServiceAccepted={setTermsOfServicesAccepted}
              overstapDatum={overstapDatum}
              setOverstapDatum={setOverstapDatum}
              kvkNummer={kvkNummer}
              bedrijfsnaam={bedrijfsNaam}
              betaalmethode={betaalmethode}
              setBetaalmethode={setBetaalmethode}

            />
          </div>
        )
      case 15:
        return (
          <div class="BestellingAanmaken">
            <BestellingAanmaken
              chosenPakket={chosenPakket}
              chosenProduct={chosenProduct}
              geslacht={geslacht}
              warmtepomp={warmtepomp}
              elektrischeAuto={electricCarWithCharger}
              availableMeters={availableMeterTypes}
              voornaam={voornaam}
              achternaam={achternaam}
              email={email}
              telefoonnummer={telefoonnummer}
              geboorteDatum={geboorteDatum}
              chosenUsage={finalChosenUsage}
              returnedEnergyAmount={returnedEnergyAmount}
              chosenEntity={entiteit}
              kvkNummer={kvkNummer}
              bedrijfsnaam={bedrijfsNaam}
              setIsFetchingData={setIsFetchingData}
              overstapDatum={overstapDatum}
              betaalmethode={betaalmethode}
              selectedEan={selectedEan}
              submissionFailed={submissionFailed}
              setSubmissionFailed={setSubmissionFailed}
              submissionFailedWithReasons={submissionFailedWithReasons}
              setSubmissionFailedWithReasons={setSubmissionFailedWithReasons}
              submissionSuccessful={submissionSuccessful}
              setSubmissionSuccessful={setSubmissionSuccessful}


            />
          </div>
        )
    }
  };
  const isNextDisabled = isFetchingData ||
    (currentStep === 2 && hasNonEmptyErrors(validationErrors.step2)) ||
    (currentStep === 0 && hasNonEmptyErrors(validationErrors.step0)) ||
    (currentStep === 12 && hasNonEmptyErrors(validationErrors.step12));
  // (currentStep === 4 && hasNonEmptyErrors(validationErrors.step4));

  return (
    <div className="main-container">
      <div className="left-content">
        <ExplainerHeader
          steps={steps}
          currentStep={currentStep}
          currentGroup={currentGroup}
          handleGroupStepClick={handleGroupStepClick}
        />
        <div className="aanmeldstraat-container">


          {renderStep()}
          {/* Error message container */}
          {
            validationErrors[`step${currentStep}`] &&
            validationErrors[`step${currentStep}`].length > 0 &&
            // Pre-check to see if there's at least one error message to display
            validationErrors[`step${currentStep}`].some(error => Array.isArray(error) ? error[1] !== false : true) && (
              <div className="error-container">
                <ul>
                  {validationErrors[`step${currentStep}`].map((error, index) => {
                    if (Array.isArray(error)) {
                      // Only render the error message if the second item is not false
                      return error[1] !== false ? <li key={index}>{error[0]}</li> : null;
                    } else {
                      // Error is not an array, so render the error message
                      return <li key={index}>{error}</li>;
                    }
                  })}
                </ul>
              </div>
            )
          }




          <div className="navigation">
            {currentStep > 0 && (currentStep !== 15 || submissionFailedWithReasons) && (
              <a href="#" onClick={onPrevClick} disabled={isFetchingData}>Vorige</a>
            )}

            {currentStep < 14 && (
              <button className="btn btn-primary" onClick={onNextClick} disabled={isNextDisabled}>Volgende</button>
            )}
            {currentStep === 14 && (
              <button className="btn btn-primary" onClick={onNextClick} disabled={isFetchingData}>Offerte aanvragen</button>
            )}
          </div>
        </div>
      </div>
      {/* <div class="betrouwbaarheid-container">
        <StepperComponent
          steps={steps}
          currentGroup={currentGroup}

          handleGroupStepClick={handleGroupStepClick}
        />

      </div> */}

    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('react-root'));
root.render(<App />);

